import React from 'react';
import { Switch } from 'new/elements/Switch';
import useSourcesAdapter from 'new/state/sources/adapter/useSourcesAdapter';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { UPDATE_SOURCE_INFO_REQUEST } from 'js/constants/actionTypes';
import { Stack } from 'new/elements/Stack';
import { CircularProgress } from '@mui/material';

interface ChangeIngestionModeProps {
  data: any;
  loadingClassName?: string;
}

export const ChangeIngestionMode = (props: ChangeIngestionModeProps) => {
  const { data } = props;
  const isSampling = data.ingestion_mode === 'sampling';

  const { requestUpdateSourceById } = useSourcesAdapter();
  const isLoading = useIsLoading(UPDATE_SOURCE_INFO_REQUEST);

  const onChangeIngestion = (e) => {
    e.stopPropagation();
    const { checked } = e.target;
    requestUpdateSourceById(data.id, {
      ingestion_mode: checked ? 'sampling' : 'full_ingestion',
    });
  };

  if (isLoading) {
    return (
      <Stack
        width="40px"
        height="24px"
        margin="9px"
        alignItems="center"
        justifyContent="center"
        className={props.loadingClassName}
      >
        <CircularProgress size={20} thickness={4} />
      </Stack>
    );
  }

  return <Switch checked={isSampling} onChange={onChangeIngestion} />;
};
